export enum FormattedCareType {
  BABYSITTER = 'babysitter',
  NANNY = 'nanny',
  PET_CARE = 'petCare',
  HOUSEKEEPING = 'housekeeping',
  COMPANION_CARE = 'companionCare',
}

export const isChildCare = (careType?: string): boolean => {
  return careType === FormattedCareType.BABYSITTER || careType === FormattedCareType.NANNY;
};

export const isBabysitter = (careType?: string): boolean => {
  return careType === FormattedCareType.BABYSITTER;
};

export const isNanny = (careType?: string): boolean => {
  return careType === FormattedCareType.NANNY;
};

export const isPetCare = (careType?: string): boolean => {
  return careType === FormattedCareType.PET_CARE;
};

export const isHousekeeping = (careType?: string): boolean => {
  return careType === FormattedCareType.HOUSEKEEPING;
};

export const isCompanionCare = (careType?: string): boolean => {
  return careType === FormattedCareType.COMPANION_CARE;
};
